// modules
import { createSelector } from 'reselect'

const reports = (state) => state.reports

export const urgentCareReportList$ = createSelector(
  reports,
  (reports) => reports.urgentCareReport.urgentCareReportList
)
